import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  ${mediaQuery(BREAKPOINTS.header, 'min')} {
    display: none;
  }
`;

const OPEN_BUTTON_OPPOSITE_COLOR = {
  blue: 'light',
  light: 'blue',
};

export const OpenButton = styled.label<{ color: 'blue' | 'light' }>`
  cursor: pointer;
  /* color: ${(props) => props.theme.color[props.color ?? 'dark'].default}; */
  color: ${(props) =>
    props.theme.color[OPEN_BUTTON_OPPOSITE_COLOR[props.color] as 'blue' | 'light'].default};
  background: ${(props) => props.theme.color[props.color].default};
  padding: 0 18px;
  border-radius: 20px;
  font-size: 16px;
  height: 32px;
  line-height: 34px;
  display: block;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;
  &[aria-checked='true'] {
    ~ [data-drawer-content] {
      transition: right 0.3s ease-in-out;
      visibility: visible;
      right: 0;
    }
    ~ [data-drawer-overlay] {
      transition: opacity 0.3s ease-in-out;
      transform: translate(0);
      opacity: 1;
    }
  }
`;

export const Overlay = styled.label`
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  z-index: 2000;
  cursor: pointer;
  width: 100vw;
  height: 100vh;
  top: 0;
  transform: translate(9999px);
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
`;

export const Drawer = styled.div`
  overflow-y: auto;
  transition: right 0.3s ease-in-out;
  right: 0;
  z-index: 2001;
  position: fixed;
  background: ${(props) => props.theme.color.light.default};
  max-width: 400px;
  right: -400px;
  width: 85vw;
  top: 0;
  bottom: 0;
  padding: 72px 24px 24px 24px;
`;

export const DrawerContainer = styled.div<{ alignTop?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  ${(props) => props.alignTop === 'true' && 'justify-content: flex-start;'}
`;

export const DrawerClose = styled.label`
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 12px;
  z-index: 1;
  cursor: pointer;
  font-size: 20px;
`;

export const MainLink = styled(Link)`
  display: block;
  cursor: pointer;
  color: ${(props) => props.theme.color.medium.shade};
  font-size: 14px;
  font-weight: 600;
  padding: 13px 20px;
  margin: 3px 0;

  position: relative;

  &:hover::after {
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.1);
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

export const SubLink = styled(MainLink)`
  cursor: pointer;
  border-radius: 5px;
  margin-left: 20px;
  font-size: 14px;
  padding: 8px 15px;
`;

export const LanguageSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

export const ButtonWrapper = styled.label`
  margin: 5px 0;
`;

export const accordionWrapperStyle = (theme: Theme) => css`
  border-radius: 0;
  box-shadow: none;
  margin: 0;
`;

export const accordionLabelStyle = (theme: Theme) => css`
  cursor: pointer;
  background: none;
  font-size: 14px;
  font-weight: 700;
  padding: 13px 20px;
  margin: 3px 0;
  position: relative;

  &:hover::after {
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.1);
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;
